module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"save_order":"save order","click_edit":"Click to edit"},"id":{"save_order":"simpan order","click_edit":"klik untuk edit"}}')
  delete Component.options._Ctor
}
